// extracted by mini-css-extract-plugin
export var errorIcon = "_jp-1";
export var nameLogo = "_jp-0";